import { TimeCalendar as TimeCalendarIcon } from '@griegconnect/krakentools-react-icons'
import { Box, IconButton, InputAdornment, FormHelperText } from '@mui/material'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { DateTimePicker as DateTimePickerMUI } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DateTime } from 'luxon'
import { Control, Controller, get, useFormState } from 'react-hook-form'
import 'react-international-phone/style.css'
import { ErrorHelperText } from './ErrorHelper'
import { useState } from 'react'

interface DateTimePickerProps {
  control: Control<any>
  className?: string | undefined
  required?: boolean
  disabled?: boolean
  name: string
  label: string
  disablePast?: boolean
  clearable?: boolean
  maxDate?: DateTime | null
  minDate?: DateTime | null
  maxDateTime?: DateTime | null
  minDateTime?: DateTime | null
  maxTime?: DateTime | null
  minTime?: DateTime | null
  format?: string
  helperText?: string
  onViewChange?: (view: string) => void
}

export const DateTimePicker = ({
  control,
  name,
  disabled,
  maxDate,
  label,
  disablePast,
  minDate,
  required,
  minDateTime,
  maxDateTime,
  maxTime,
  minTime,
  format,
  helperText,
  onViewChange,
}: DateTimePickerProps) => {
  const { errors } = useFormState()
  const error = get(errors, name)

  const [open, setOpen] = useState(false)

  return (
    <Box pb={1}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DateTimePickerMUI
              value={field.value}
              onViewChange={onViewChange}
              onChange={field.onChange}
              onClose={() => setOpen(false)}
              open={open}
              disabled={disabled ?? false}
              ampm={false}
              format={format ?? 'dd.MM.yyyy HH:mm'}
              disablePast={disablePast ?? false}
              maxDate={maxDate ?? undefined}
              minDate={minDate}
              minDateTime={minDateTime}
              maxDateTime={maxDateTime}
              minTime={minTime}
              maxTime={maxTime}
              slotProps={{
                textField: {
                  required: required,
                  fullWidth: true,
                  variant: 'filled',
                  label,
                  // style: { marginBottom: 10 },
                  InputProps: {
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton size="large" onClick={() => setOpen(true)}>
                          <TimeCalendarIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                },
              }}
            />
          )}
        />
      </LocalizationProvider>
      {error && error.message && <ErrorHelperText error={error.message} />}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </Box>
  )
}
